const PrefixUrl = '/:company';

const PaymentList = PrefixUrl + '/payments/payment-list';

const ErrorRoutes = {
  Notfound: '/404',
  UnAuthorized: '/unauthorized',
};
const RouterNoPrefix = {
  Video: '/video',
  VideoAndroid: '/video/android',
  VideoPaymentDNBAndroid: '/video/pay-dnb-android',
  VideoPaymentSP1Android: '/video/pay-sp1-android',
  EditDescriptionTask: '/task-description-webview',
  EditCommentTask: '/task-edit-comment-webview',
  CreateCommentTask: '/task-create-comment-webview',
  ConsentSignant: '/consent/sca-callback',
  ZtlPaymentCallBack: '/ztl-payment/sca-callback',
  OnboardingCallback: '/onboarding/callback',
  ZtlPaymentCancelCallback: '/ztl-payment/cancel-callback',
  Invoice: '/video/invoice-web',
};
const RoutesUrl = {
  Dashboard: PrefixUrl + '/',
  Voucher: PrefixUrl + '/voucher',
  Bank: PrefixUrl + '/bank',
  BankManagement: PrefixUrl + '/bank-management',
  BankImport: PrefixUrl + '/bank/import-document',
  PaymentList,
  PaymentInternationalList: PaymentList + '/international',
  InternalTransfer: PrefixUrl + '/payments/internal-transfer',
  PaymentList_AssignUsers: PrefixUrl + '/payments/assign-users',
  ConnectMissing: PrefixUrl + '/connect-missing',
  Setting: PrefixUrl + '/setting',
  SettingZTLConsent: PrefixUrl + '/setting/ztl-consent/:id/renew',
  Inbox: PrefixUrl + '/inbox',
  InboxDetail: PrefixUrl + '/inbox/:uuid',
  AdminImportAuto: PrefixUrl + '/admin-import-auto',
  AdminAutoImport: PrefixUrl + '/admin-auto-import',
  AdminBankDivision: PrefixUrl + '/admin-bank-division',
  AdminImportManual: PrefixUrl + '/admin-import-manual',
  AdminEHF: PrefixUrl + '/admin-ehf',
  AdminEhfReport: PrefixUrl + '/admin-ehf-report',
  AdminEhfSpam: PrefixUrl + '/admin-ehf/spam',
  AdminEhfSpamData: PrefixUrl + '/admin-ehf/spam-data',
  AdminEhfPaymentSetting: PrefixUrl + '/admin-ehf/payment-setting',
  AdminVoucher: PrefixUrl + '/admin-voucher',
  AdminEmail: PrefixUrl + '/admin-email',
  AdminMailgun: PrefixUrl + '/admin-maingun',
  AdminTask: PrefixUrl + '/task-overview',
  Unauthorized: PrefixUrl + '/unauthorized',
  AiSettingGlobal: PrefixUrl + '/ai-setting/ai-global',
  AiSettingLocal: PrefixUrl + '/ai-setting/ai-local',
  AdminSettingAiVoucher: PrefixUrl + '/admin-setting/ai-voucher',
  AdminSettingAiVoucherData: PrefixUrl + '/admin-setting/ai-voucher-data',
  BankVerify: PrefixUrl + '/bank-verify',
  SignCancel: PrefixUrl + '/sign-cancel',
  SignNext: PrefixUrl + '/sign-next',
  Task: PrefixUrl + '/task',
  TaskTag: PrefixUrl + '/task/label',
  TaskTemplate: PrefixUrl + '/task/template',
  TaskTemplateGlobal: PrefixUrl + '/task/template-global',
  Statistics: PrefixUrl + '/statistics',
  StatisticPayment: PrefixUrl + '/statistic/payment',
  StatisticVoucher: PrefixUrl + '/statistic/voucher',
  StatisticBank: PrefixUrl + '/statistic/bank',
  StatisticMVA: PrefixUrl + '/statistic/mva',
  StatisticZtl: PrefixUrl + '/statistic/ztl',
  StatisticFiken: PrefixUrl + '/statistic/fiken',
  StatisticInvitation: PrefixUrl + '/statistic/invitation',
  TeamBilagSkyOverview: PrefixUrl + '/bilagsky-team/overview',
  Consent: PrefixUrl + '/consent',
  TeamBilagSkyKPI: PrefixUrl + '/bilagsky-team/kpi',
  AdminMornitoring: {
    fiken: PrefixUrl + '/admin/monitoring/fiken',
    fikenPurchase: PrefixUrl + '/admin/monitoring/fiken/purchase',
    fikenJournalEntry: PrefixUrl + '/admin/monitoring/fiken/journal-entry',
    fikenSetting: PrefixUrl + '/admin/monitoring/fiken/setting',
    fikenSupplier: PrefixUrl + '/admin/monitoring/fiken/supplier',
    fikenEcoFinansSupplier: PrefixUrl + '/admin/monitoring/fiken/eco-finans-supplier',
    fikenTransaction: PrefixUrl + '/admin/monitoring/fiken/transaction',
    tripletex: PrefixUrl + '/admin/monitoring/tripletex',
    tripletexPurchase: PrefixUrl + '/admin/monitoring/tripletex/purchase',
    tripletexSupplier: PrefixUrl + '/admin/monitoring/tripletex/supplier',
  },
  Integration: {
    overview: PrefixUrl + '/integration',
    voucher: PrefixUrl + '/integration/voucher',
    productLines: PrefixUrl + '/integration/product-lines',
  },
  AdminBankTemplates: PrefixUrl + '/admin-bank-templates',
};

export { ErrorRoutes, RoutesUrl, PrefixUrl, RouterNoPrefix };
